export class AssetPresetStlModel {

  uid: number;
  name: string;
  defaultStls: any;
  description: string;

  constructor() {


  }
}